import ForecastTypeLogic from "../logic/forecastTypeLogic";
//import PowMon from "./powmon/powMon";
import { MapAppMode } from "../models/metMap/mapAppMode";
class AppSettings {
}
AppSettings.AppMode = MapAppMode.PQWEB;
AppSettings.MPOINT_GLOW_UPDATE = 3;
AppSettings.PQ4CAST_DATA_TYPES = ForecastTypeLogic.all();
///Diverse Quick and dirty-inställningar som antagligen inte pillas på
AppSettings.SHOW_ERROR_ALERTS = false;
AppSettings.SHOW_HULLS = true;
AppSettings.MAIN_CYCLE_WAIT = 30000;
AppSettings.BATCH_CYCLE_WAIT_FIRST = 1;
AppSettings.BATCH_CYCLE_WAIT_REST = 30000;
AppSettings.BATCH_SIZE = 10;
export default AppSettings;
